var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosmosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.052,
    height: 35.027,
    viewBox: "0 0 35.052 35.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cosmosIcon",
    d: "M33.446,12.584c2.063-4.683,2.217-8.738,0-10.948s-6.261-2.059-10.944.007A16.668,16.668,0,0,0,1.627,22.5c-.123.277-.242.551-.351.824-1.814,4.5-1.691,8.1.347,10.141a6.071,6.071,0,0,0,4.444,1.6,16.546,16.546,0,0,0,6.5-1.61,15.917,15.917,0,0,0,2.171.519,16.313,16.313,0,0,0,2.8.239A16.668,16.668,0,0,0,33.965,14.752,16.4,16.4,0,0,0,33.446,12.584ZM12.5,31.207a22.58,22.58,0,0,1-2.687,1.1c-3.062,1.007-5.476.891-6.7-.333s-1.343-3.641-.333-6.7a16.354,16.354,0,0,0,.993,1.652,16.656,16.656,0,0,0,4.392,4.392c.389-.091.793-.2,1.21-.34.452-.151.923-.326,1.41-.533a14.556,14.556,0,0,1,8.79-27.308,14.327,14.327,0,0,1,3.031.768A14.651,14.651,0,0,1,30.433,10.8c.2-.481.379-.951.53-1.414.137-.417.253-.821.34-1.21A16.923,16.923,0,0,0,25.287,2.8a12.031,12.031,0,0,1,3.69-.684,4.088,4.088,0,0,1,2.985,1.007c1.224,1.224,1.34,3.638.333,6.7a21.735,21.735,0,0,1-1.1,2.683,40.985,40.985,0,0,1-7.952,10.744A41.02,41.02,0,0,1,12.5,31.207ZM32.092,17.955A14.582,14.582,0,0,1,17.952,32.1c-.137,0-.277,0-.414,0a14.491,14.491,0,0,1-2.04-.144,45.517,45.517,0,0,0,9.231-7.222,45.545,45.545,0,0,0,7.223-9.229,14.479,14.479,0,0,1,.144,2.038C32.1,17.684,32.092,17.821,32.092,17.955Z",
    transform: "translate(0 -0.035)",
    fill: "#763D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmosIcon);
export default __webpack_public_path__ + "static/media/cosmos-icon.cb1b48cb8e364245200f012285c4edf8.svg";
export { ForwardRef as ReactComponent };